import { normalizeElement } from './normalize-element'

export const normalizeCategorySub = (rawData) => {
  const { code = '', element_list: elementList = [] } = rawData

  return {
    code,
    elementList: elementList?.map(normalizeElement)
  }
}

export const normalizeCategory = (rawData) => {
  const {
    code = '',
    element_list: elementList = [],
    sub_list: subList = []
  } = rawData

  return {
    code,
    elementList: elementList?.map(normalizeElement),
    subList: subList?.map(normalizeCategorySub)
  }
}
